<ui-tooltip arrow="left"
            left="-3"
            [textNowrap]="true"
            [hideTip]="!tooltip"
            position="top">
  <a class="ui-category-block-header-control__item"
     ngProjectAs="content"
     [class.ui-category-block-header-control__item_active]="isActive">
    <lucide-icon [name]="lucideName" [ngClass]="cssClass" [size]="18" aria-hidden="true"></lucide-icon>
  </a>
  <span ngProjectAs="tip">{{tooltip}}</span>
</ui-tooltip>
